import { Box, Card, Container, Divider, Link, Typography } from "@mui/material";
import type { NextPage } from "next";
import Head from "next/head";
import NextLink from "next/link";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { AmplifyRegister } from "../../components/authentication/amplify-register";
import { GuestGuard } from "../../components/authentication/guest-guard";
import { Logo } from "../../components/logo";
import { useAuth } from "../../hooks/use-auth";
import { gtm } from "../../lib/gtm";

const platformIcons = {
  Amplify: "/images/icons/amplify.svg",
  Auth0: "/images/icons/auth0.svg",
  Firebase: "/images/icons/firebase.svg",
  JWT: "/images/icons/jwt.svg",
};

const Register: NextPage = () => {
  const router = useRouter();
  const { platform } = useAuth() as any;
  const { disableGuard, returnUrl } = router.query;

  useEffect(() => {
    gtm.push({ event: "page_view" });
    if (typeof window !== "undefined" && returnUrl) {
      window.localStorage.setItem("returnUrl", String(returnUrl));
    }
  }, []);

  return (
    <>
      <Head>
        <title>Register | SEOwind.io</title>
      </Head>
      <Box
        component="main"
        sx={{
          backgroundColor: "background.default",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            py: {
              xs: "60px",
              md: "120px",
            },
          }}
        >
          <Card elevation={16} sx={{ p: 4 }}>
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <NextLink href="https://seowind.io" passHref>
                <a>
                  <Logo
                    sx={{
                      height: 31,
                      width: 148,
                    }}
                  />
                </a>
              </NextLink>
              <Typography variant="h4" sx={{ pt: 2 }}>
                Create your account
              </Typography>
              <Typography color="textSecondary" sx={{ mt: 2 }} variant="body2">
                You'll be up & running in no time
              </Typography>
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                mt: 3,
              }}
            >
              {platform === "Amplify" && <AmplifyRegister />}
            </Box>
            <Divider sx={{ my: 3 }} />
            <NextLink
              href={
                disableGuard
                  ? `/authentication/login?disableGuard=${disableGuard}`
                  : "/authentication/login"
              }
              passHref
            >
              <Link color="textSecondary" variant="body2">
                Already have an account? Log in to SEOwind
              </Link>
            </NextLink>
          </Card>
        </Container>
      </Box>
    </>
  );
};

Register.getLayout = (page) => <GuestGuard>{page}</GuestGuard>;

export default Register;
